<template>
    <SkeletonCoachFooter v-if="isLoading" />
    <div v-else class="tw-relative tw-bg-black">
        <div class="tw-text-white">
            <div class="sm:tw-py-12 md:tw-py-12 lg:tw-py-16 tw-py-16 tw-px-14">
                <div class="tw-flex tw-flex-col-reverse lg:tw-flex-row">
                    <div class="tw-flex-grow lg:tw-pr-6">
                        <h1 class="tw-text-4xl tw-mb-2 tw-uppercase tw-font-normal">
                            {{ firstName }} <span class="tw-font-bold">{{ lastName }}</span>
                        </h1>
                        <div class="tw-uppercase tw-font-semibold tw-mb-6" style="color: #7E9AB1;">
                            {{ focusText }}
                        </div>
                        <h2 class="tw-mb-10 tw-text-base tw-font-normal tw-max-w-4xl" v-html="bio"></h2>
                    </div>
                    <div class="lg:tw-h-48 lg:tw-w-48">
                        <div
                            class="tw-mx-auto tw-mb-6 lg:tw-mb-0 lg:tw-mx-0 lg:tw-mr-4 tw-rounded-full tw-relative tw-w-48 tw-h-48 tw-overflow-hidden tw-flex-shrink-0">
                            <img class="tw-w-48 tw-h-48 tw-rounded-full tw-border-4 tw-border-solid tw-border-yellow-500"
                                 :src="`https://www.musora.com/cdn-cgi/image/width=300,quality=95/${headShot}`">
                            <!-- Badge -->
                            <div
                                class="tw-bg-yellow-500 tw-absolute tw-w-full tw-h-6 tw-left-0 tw-bottom-0 tw-z-10 tw-flex tw-items-center tw-justify-center">
                                <musora-icon
                                    icon-name="whistle-filled"
                                    height="20"
                                    class="tw-text-white tw-w-[20px] tw-leading-none"
                                ></musora-icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tw-bg-off-black tw-text-white">
<!--                    <div class="tw-text-4xl">Bio</div>-->
<!--                    <div class="tw-py-4">-->
<!--                        {!! $longBio !!}-->
<!--                    </div>-->
                    <template v-if="bands">
                        <h1 class="tw-text-2xl tw-uppercase tw-font-normal">Bands</h1>
                        <div class="tw-font-normal mt-1 mb-3">
                            <span>{{ bands }}</span>
                        </div>
                    </template>

                    <template v-if="endorsements">
                        <h1 class="tw-text-2xl tw-uppercase tw-font-normal">Endorsements</h1>
                        <div class="tw-font-normal mt-1">{{ endorsements }}</div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia/dist/pinia";
import { usePlatformStore } from "@stores/platform";
import SkeletonCoachFooter from '@collections/SkeletonLoader/SkeletonCoachFooter';

const props = defineProps({
    coachData: {
        type: Object,
        default: () => {}
    },
    fullName:{
        type: String,
        default: ''
    },
})

const platformStore = usePlatformStore();
const { isLoading } = storeToRefs(platformStore);

const firstName = computed(() => {
    return props.fullName?.split(' ')[0];
})

const lastName = computed(() => {
    return props.fullName?.split(' ').slice(1).join(' ');
})

const focusText = computed(() => {
    return props.coachData?.focus?.join(', ');
})

const bio = computed(() => {
    return props.coachData?.long_bio;
})

const headShot = computed(() => {
    return props.coachData?.head_shot_picture_url;
})

const bands = computed(() => {
    return props.coachData?.bands;
})

const endorsements = computed(() => {
    return props.coachData?.endorsements;
})
</script>
